<template>
  <div class="row">
    <b-container fluid>
      <b-card no-body>
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <div class="m-2">
            <b-form>
              <b-row>
                <b-col
                  cols="12"
                  md="4"
                >
                  <b-form-group
                    label-for="admissionRoundId"
                  >
                    <v-select
                      v-model="filter.admissionRoundId"
                      :options="admissionRounds"
                      :reduce="option => option.value"
                      placeholder="Đợt tuyển sinh"
                      @input="readAdmissionForm"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  cols="12"
                  md="4"
                >
                  <b-form-group
                    label-for="admissionFormId"
                  >
                    <v-select
                      v-model="filter.admissionFormId"
                      :options="dataListAdmissionForm"
                      :reduce="option => option.value"
                      placeholder="Phương thức tuyển sinh"
                      @input="selectAdmissionForm"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  cols="12"
                  md="4"
                >
                  <b-form-group
                    label-for="admissionMajorId"
                  >
                    <v-select
                      v-model="filter.admissionMajorId"
                      :options="dataListMajorByAdmissionForm"
                      :reduce="option => option.value"
                      placeholder="Ngành tuyển sinh"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <div class="text-right">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="primary"
                      class="ml-1"
                      @click="onSearchMainData"
                    >
                      Danh sách thí sinh ứng tuyển
                    </b-button>
                    <b-button
                      v-if="admissionAccepted"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="danger"
                      class="ml-1"
                      @click="onFilterMainData"
                    >
                      Lọc theo điều kiện đầu vào
                    </b-button>
                    <b-button
                      v-if="admissionAccepted"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="info"
                      class="ml-1"
                      @click="onAdmissionMainData"
                    >
                      <span class="text-nowrap text-right">Xét tuyển</span>
                    </b-button>
                    <b-button
                      v-if="createPriorityOrder"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="success"
                      class="ml-1"
                      @click="getAdmissionDataFromStore"
                    >
                      Danh sách thí sinh trúng tuyển
                    </b-button>
                    <b-button
                      v-if="resetApplicantStudentAccepted && checkPublicResults"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="warning"
                      class="ml-1"
                      @click="deleteAdmissionAccepted"
                    >
                      Xóa kết quả xét tuyển
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </b-form>
            <b-row class="mt-0">
              <b-col cols="12">
                <div class="d-flex align-items-center mb-1 mt-1">
                  <span class="text-nowrap"> Hiển thị {{ filter.itemsPerPage * (filter.currentPage-1) +1 }}
                    đến {{ (filter.itemsPerPage * (filter.currentPage) >= totalRows)? totalRows : filter.itemsPerPage * (filter.currentPage) }} &nbsp; của {{ totalRows }} bản ghi
                  </span>
                </div>
                <vue-good-table
                  mode="remote"
                  class="my-table"
                  style-class="vgt-table striped bordered"
                  row-style-class="vgt-row"
                  :columns="columns"
                  :line-numbers="true"
                  :rows="mainData"
                  :pagination-options="paginationOptions"
                  :total-rows="totalRows"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                >
                  <div
                    slot="emptystate"
                    style="text-align: center; font-weight: bold"
                  >
                    Không có bản ghi nào !
                  </div>
                  <template
                    slot="table-row"
                    slot-scope="props"
                  >
                    <span
                      v-if="props.column.field === 'status'"
                      :class="(props.row.status === 1) ? 'text-danger font-weight-bold' : 'text-warning'"
                    >
                      {{ getStatusName(props.row.status) }}
                    </span>
                    <span
                      v-else-if="props.column.field === 'action'"
                      class="thead-group-action"
                    >
                      <b-button-group>
                        <b-button
                          variant="info"
                          class="btn-icon"
                          size="sm"
                        >
                          <feather-icon icon="ListIcon" />
                        </b-button>
                      </b-button-group>
                    </span>
                    <!-- Column: Common -->
                    <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                  </template>
                  <!-- pagination -->
                  <template
                    slot="pagination-bottom"
                    slot-scope="props"
                  >
                    <div class="d-flex justify-content-between flex-wrap">
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Hiển thị {{ filter.itemsPerPage * (filter.currentPage-1) +1 }}
                          đến {{ (filter.itemsPerPage * (filter.currentPage) >= totalRows)? totalRows : filter.itemsPerPage * (filter.currentPage) }} &nbsp; của {{ totalRows }} bản ghi
                        </span>
                      </div>
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Hiển thị </span>
                        <b-form-select
                          v-model="filter.itemsPerPage"
                          :options="itemsPerPageOptions"
                          class="mx-1"
                          @input="(value) => props.perPageChanged({ currentPerPage: value })"
                        />
                        <span class="text-nowrap"> bản ghi/trang</span>
                      </div>
                      <div>
                        <b-pagination
                          :value="1"
                          :total-rows="totalRows"
                          :per-page="filter.itemsPerPage"
                          class="mt-1 mb-0"
                          @input="(value) => props.pageChanged({ currentPage: value })"
                        />
                      </div>
                    </div>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import {
  BButton,
  BButtonGroup,
  BCard,
  BCol,
  BContainer,
  BForm,
  BFormGroup,
  BFormSelect,
  BOverlay,
  BPagination,
  BRow,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import { mapActions, mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import '@core/scss/vue/libs/vue-good-table.scss'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { getUser } from '@/auth/utils'
import { hasPermissionForResource } from '@/utils'
import { PermissionCode, ResourceCode } from '@/const/code'

export default {
  name: 'AspirationScore',
  directives: {
    Ripple,
  },
  components: {
    BButton,
    BButtonGroup,
    BCard,
    BRow,
    BCol,
    BContainer,
    BFormSelect,
    BOverlay,
    BPagination,
    VueGoodTable,
    BFormGroup,
    BForm,
    vSelect,
  },
  data() {
    return {
      user: getUser(),
      isLoading: false,
      filter: {
        currentPage: 1,
        itemsPerPage: 10,
        organizationId: getUser().orgId,
        admissionRoundId: null,
        admissionFormId: null,
        admissionMajorId: null,
        sort: null,
      },
      paginationOptions: {
        enabled: true,
      },
      itemsPerPageOptions: [10, 20, 30, 50, 100],
      currentName: '',
      currentCode: '',
      isFilter: false,
      admission: false,
      isAccepted: false,
      checkPublicResults: true,
    }
  },
  computed: {
    ...mapGetters({
      mainData: 'aspirationInformation/dataLists',
      totalRows: 'aspirationInformation/totalRows',
      resourceName: 'admissionScore/resourceName',
      dataListMajorByAdmissionForm: 'admissionMajor/dataListMajorByAdmissionForm',
      admissionRounds: 'admissionRound/admissionRoundsByOrganization',
      dataListAdmissionForm: 'admissionForm/admissionFormByAdmissionRoundId',
    }),
    columns() {
      return [
        {
          label: 'CCCD thí sinh',
          field: 'identification',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Họ tên thí sinh ứng tuyển',
          field: 'applicantStudentName',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Phương thức tuyển sinh',
          field: 'admissionFormName',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Ngành ứng tuyển',
          field: 'majorName',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Tổ hợp xét tuyển',
          field: 'admissionBlockName',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Điểm xét tuyển',
          field: 'admissionScore',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Thứ tự ưu tiên',
          field: 'priorityOrder',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Thứ tự nguyện vọng',
          field: 'orderNo',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ]
    },
    createPriorityOrder() {
      return hasPermissionForResource(PermissionCode.CREATE, ResourceCode.APPLICANT_STUDENT_PRIORITY_ORDER)
    },
    resetApplicantStudentAccepted() {
      return hasPermissionForResource(PermissionCode.DELETE, ResourceCode.APPLICANT_STUDENT_ACCEPTED)
    },
    admissionAccepted() {
      return hasPermissionForResource(PermissionCode.UPDATE, ResourceCode.FILTER_ADMISSION_ASPIRATION_INFORMATION)
    },
  },
  async created() {
    this.updateParams({ organizationId: this.user.orgId })
    this.isLoading = true
    try {
      await this.getAdmissionRoundsByOrganization({ organizationId: getUser().orgId })
    } catch (e) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: `[${e.code}] ${e.message}`,
          icon: 'XCircleIcon',
          variant: 'danger',
        },
      })
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    ...mapActions({
      getMainData: 'aspirationInformation/getData',
      getDataAdmission: 'aspirationInformation/getDataAdmission',
      filterAspirationInformation: 'aspirationInformation/filterAspirationInformation',
      acceptAspirationInformation: 'aspirationInformation/acceptAspirationInformation',
      getMajorByAdmissionFormId: 'admissionMajor/getMajorByAdmissionFormId',
      readAdmissionFormByAdmissionRoundId: 'admissionForm/readAdmissionFormByAdmissionRoundId',
      getAdmissionRoundsByOrganization: 'admissionRound/readAdmissionRoundsByOrganization',
      resetApplicantStudentAcceptedResults: 'aspirationInformation/resetApplicantStudentAcceptedResults'
    }),
    async readAdmissionForm(id) {
      await this.readAdmissionFormByAdmissionRoundId({ admissionRoundId: id })
      await this.getMajorByAdmissionFormId()
    },
    async selectAdmissionForm(id) {
      await this.getMajorByAdmissionFormId({ admissionFormId: id })
    },
    updateParams(newProps) {
      this.filter = { ...this.filter, ...newProps }
    },
    async onPageChange(param) {
      this.updateParams({ currentPage: param.currentPage })
      this.isFilter ? await this.getAdmissionDataFromStore() : await this.getMainDataFromStore()
    },
    async getMainDataFromStore() {
      if (this.filter.admissionRoundId === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Đợt tuyển sinh không được để trống!',
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
        return
      }
      this.isLoading = true
      try {
        await this.getMainData(this.filter)
        this.isFilter = false
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    async getAdmissionDataFromStore() {
      if (this.filter.admissionRoundId === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Đợt tuyển sinh không được để trống!',
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
        return
      }
      this.isLoading = true
      try {
        await this.getDataAdmission(this.filter)
        this.isFilter = true
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    async deleteAdmissionAccepted() {
      this.$swal({
        title: 'Bạn chắc chắn muốn xóa xóa hết dữ liệu xét tuyển',
        text: 'Bạn sẽ không thể khôi phục lại dữ liệu này!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isLoading = true
          try {
            const response = await this.resetApplicantStudentAcceptedResults(this.filter.admissionRoundId)
            if (response) {
              const { isSuccessful, message } = response
              if (isSuccessful) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: message,
                    icon: 'CheckIcon',
                    variant: 'success',
                  },
                })
                try {
                  await this.getAdmissionDataFromStore(this.filter)
                } catch (e) {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: `[${e.code}] ${e.message}`,
                      icon: 'XCircleIcon',
                      variant: 'danger',
                    },
                  })
                }
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: message,
                    icon: 'XCircleIcon',
                    variant: 'danger',
                  },
                })
              }
            }
          } catch (e) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `[${e.code}] ${e.message}`,
                icon: 'XCircleIcon',
                variant: 'danger',
              },
            })
          } finally {
            this.isLoading = false
          }
        }
      })
    },
    async onPerPageChange(param) {
      this.updateParams({ currentPage: 1, itemsPerPage: param.currentPerPage })
      this.isFilter ? await this.getAdmissionDataFromStore() : await this.getMainDataFromStore()
    },
    async onSortChange(param) {
      if (param.length > 0) {
        const {
          field,
          type,
        } = param[0]
        const selectedColumn = this.columns.findIndex(e => e.field === field)
        this.updateParams({ sort: `${selectedColumn}_${type}` })
      }
      this.isFilter ? await this.getAdmissionDataFromStore() : await this.getMainDataFromStore()
    },
    async onColumnFilter(param) {
      const { columnFilters } = param
      if (Object.hasOwn(columnFilters, 'status')) this.updateParams({ status: columnFilters.status })
      this.isFilter ? await this.getAdmissionDataFromStore() : await this.getMainDataFromStore()
    },
    getStatusName(id) {
      return this.statuses.find(status => status.value === id).label
    },
    async onSearchMainData() {
      await this.getMainDataFromStore()
    },
    async onFilterMainData() {
      if (this.filter.admissionRoundId === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Vui lòng chọn Đợt tuyển sinh!',
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
        return null
      }
      this.isLoading = true
      try {
        const response = await this.filterAspirationInformation({
          admissionRoundId: this.filter.admissionRoundId,
          checkRequired: 1,
        })
        if (response) {
          const {
            isSuccessful,
            message,
          } = response
          if (isSuccessful) {
            this.admission = true
            await this.getMainDataFromStore()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: message,
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: message,
                icon: 'XCircleIcon',
                variant: 'danger',
              },
            })
          }
        }
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
      return null
    },
    async onAdmissionMainData() {
      if (this.filter.admissionRoundId === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Vui lòng chọn Đợt tuyển sinh!',
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
        return null
      }
      this.isLoading = true
      try {
        const response = await this.acceptAspirationInformation({
          admissionRoundId: this.filter.admissionRoundId,
          admissionFormId: this.filter.admissionFormId,
          checkRequired: 0,
        })
        if (response) {
          const {
            isSuccessful,
            message,
          } = response
          if (isSuccessful) {
            this.isAccepted = true
            await this.getMainDataFromStore()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: message,
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: message,
                icon: 'XCircleIcon',
                variant: 'danger',
              },
            })
          }
        }
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
      return null
    },
  },
}
</script>
